var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"font-h4-regular"},[_vm._v(_vm._s(_vm.row[_vm.column.key]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }